import { persistentMap } from "@nanostores/persistent"
import apiRequest from "@utils/apiRequest"
import filter from "lodash/filter"
import * as cookies from "tiny-cookie"

export interface FavoriteResponse {
  favorite: Domain.HappyPlates.DataTransferObjects.FavoriteData
  group_name: string
}

export type FavoritesValue = {
  recipes: string
  bundles: string
  collections: string
  favoriteGroups: string
  defaultFavoriteGroup: string | undefined
  targetFavoriteGroupId: string | undefined
}

export const $favorites = persistentMap<FavoritesValue>("favorites:", {
  recipes: JSON.stringify([]),
  bundles: JSON.stringify([]),
  collections: JSON.stringify([]),
  favoriteGroups: JSON.stringify([]),
  defaultFavoriteGroup: undefined,
  targetFavoriteGroupId: undefined,
})

export const fetchFavorites = async () => {
  try {
    const res = await apiRequest(`/v1/favorites`, {
      token: cookies.get("token") ?? undefined,
    })

    const recipes = filter(res, (favorite) => favorite.recipe_id !== null).map((favorite) => {
      return {
        id: favorite.id,
        rId: favorite.recipe_id,
      }
    })

    const collections = filter(res, (favorite) => favorite.collection_id !== null).map((favorite) => {
      return {
        id: favorite.id,
        cId: favorite.collection_id,
      }
    })
    const bundles = filter(res, (favorite) => favorite.bundle_id !== null).map((favorite) => {
      return {
        id: favorite.id,
        bId: favorite.bundle_id,
      }
    })
    $favorites.setKey("recipes", JSON.stringify(recipes))
    $favorites.setKey("collections", JSON.stringify(collections))
    $favorites.setKey("bundles", JSON.stringify(bundles))

    // favorite groups
    if (cookies.get("token")) {
      const groupsRes = await apiRequest(`/v1/favorite-groups`, {
        token: cookies.get("token") ?? undefined,
      })

      const favoriteGroups = groupsRes.data
      $favorites.setKey("favoriteGroups", JSON.stringify(favoriteGroups))
      const defaultFavoriteGroup = groupsRes.data.find((group: any) => group.user_default_group)?.id ?? null
      $favorites.setKey("defaultFavoriteGroup", defaultFavoriteGroup)
    }
  } catch (e) {
    console.error(e)
  }
}

export const mutateFavorites = async () => {
  fetchFavorites()
}

export const setTargetFavoriteGroupId = (id: number | null) =>
  $favorites.setKey("targetFavoriteGroupId", id ? String(id) : undefined)
